export const LOGTO_GITHUB_CONNECTOR_ID = 'agentconnect-github'
export const LOGTO_GOOGLE_CONNECTOR_ID = 'agentconnect-google'
export const LOGTO_SLACK_CONNECTOR_ID = 'agentconnect-slack'
